import { render, staticRenderFns } from "./LabelTable.vue?vue&type=template&id=44961434&scoped=true&"
import script from "./LabelTable.vue?vue&type=script&lang=js&"
export * from "./LabelTable.vue?vue&type=script&lang=js&"
import style0 from "./LabelTable.vue?vue&type=style&index=0&id=44961434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44961434",
  null
  
)

export default component.exports